export const restaurantData = [
  {
    id: "1",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Lion's Head Tavern",
    streetAddress: "3085 Robie St.",
    unitNumber: "",
    city: "Halifax",
    province: "NS",
    postalCode: "B3K 4P7",
    country: "Canada",
    operationHours: {
      Dimanche: "10am - 9pm",
      Lundi: "10am - 9pm",
      Mardi: "10am - 9pm",
      Mercredi: "10am - 9pm",
      Jeudi: "10am - 9pm",
      Vendredi: "10am - 9pm",
      Samedi: "10am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://lionshead.ca/menu/",
    websiteLink:
      "https://lionshead.ca/order/?gclid=CjwKCAjwmv-DBhAMEiwA7xYrd-ztamQK4_WaeuMWlYQCrkoMqZdVJAeGP9qH2y2SzwL9Lx4PIj9PkBoCG9AQAvD_BwE",
    reservationLink:
      "https://www.sevenrooms.com/reservations/lionsheadtavernhalifax",
    latitude: 44.659654,
    longitude: -63.60167619999999
  },
  {
    id: "2",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Dirty D",
    streetAddress: "9330 Boulevard Leduc local 10",
    unitNumber: "",
    city: "Brossard",
    province: "QC",
    postalCode: "J4Y 0B3",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 1am",
      Lundi: "12pm - 1am",
      Mardi: "12pm - 1am",
      Mercredi: "12pm - 1am",
      Jeudi: "12pm - 1am",
      Vendredi: "12pm - 3am",
      Samedi: "12pm - 3am"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.dirtydivebar.com/",
    websiteLink: "https://www.dirtydivebar.com/",
    reservationLink:
      "https://www.google.com/maps/reserve/v/dine/c/AaV1yAw3h5k?source=pa&hl=en-CA&gei=DjuRYOWeOoystQaXx6SwBg&sourceurl=https://www.google.com/search?q%3Ddirty%2Bd%2Bdive%2Bbar%26rlz%3D1C5CHFA_enCA910CA910%26oq%3Ddirty%2Bd%2Bdive%2Bbar%26aqs%3Dchrome..69i57.2070j0j4%26sourceid%3Dchrome%26ie%3DUTF-8",
    latitude: 45.4473853,
    longitude: -73.43756069999999
  },
  {
    id: "3",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Baie De Beauport",
    streetAddress: "1 Boulevard Henri-Bourassa",
    unitNumber: "",
    city: "Québec",
    province: "QC",
    postalCode: "G1J 1W8",
    country: "Canada",
    operationHours: {
      Dimanche: "10am - 7pm",
      Lundi: "10am - 7pm",
      Mardi: "10am - 7pm",
      Mercredi: "10am - 7pm",
      Jeudi: "10am - 7pm",
      Vendredi: "10am - 7pm",
      Samedi: "10am - 7pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://baiedebeauport.com/fr/la-baie/boire-et-manger",
    websiteLink: "https://www.baiedebeauport.com/",
    reservationLink: null,
    latitude: 46.8682009,
    longitude: -71.2747007
  },
  {
    id: "4",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "The Village",
    streetAddress: "206 Osborne Street",
    unitNumber: "",
    city: "Winnipeg",
    province: "MB",
    postalCode: "R3L 1Z3",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: null,
    websiteLink: null,
    reservationLink: null,
    latitude: 49.8761606,
    longitude: -97.1432883
  },
  {
    id: "5",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Lone Star",
    streetAddress: "4110 Innes Rd.",
    unitNumber: "",
    city: "Orléans",
    province: "ON",
    postalCode: "K4A 3W9",
    country: "Canada",
    operationHours: {
      Dimanche: "11:30am - 9pm",
      Lundi: "11:30am - 9pm",
      Mardi: "11:30am - 9pm",
      Mercredi: "11:30am - 9pm",
      Jeudi: "11:30am - 9pm",
      Vendredi: "11:30am - 9pm",
      Samedi: "11:30am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://lonestartexasgrill.com/menus#drinks",
    websiteLink: "https://lonestartexasgrill.com/locations/orleans#reservation",
    reservationLink: "https://lonestartexasgrill.com/reservations",
    latitude: 45.4569601,
    longitude: -75.4999361
  },
  {
    id: "6",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Boston Pizza",
    streetAddress: "7 John St.",
    unitNumber: "",
    city: "Huntsville",
    province: "ON",
    postalCode: "P1H 1H2",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 9pm",
      Lundi: "12pm - 9pm",
      Mardi: "12pm - 9pm",
      Mercredi: "12pm - 9pm",
      Jeudi: "12pm - 9pm",
      Vendredi: "12pm - 9pm",
      Samedi: "12pm - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://bostonpizza.com/en/menu.html",
    websiteLink: "https://bostonpizza.com/en/locations/huntsville.html",
    reservationLink: "https://bostonpizza.com/en/reservation.html",
    latitude: 45.3284788,
    longitude: -79.2148759
  },
  {
    id: "7",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Earls Kitchen + Bar",
    streetAddress: "1095 Mainland St.",
    unitNumber: "",
    city: "Vancouver",
    province: "BC",
    postalCode: "V6B 5P9",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 11pm",
      Lundi: "11am - 11pm",
      Mardi: "11am - 11pm",
      Mercredi: "11am - 11pm",
      Jeudi: "11am - 11pm",
      Vendredi: "11am - 11pm",
      Samedi: "11am - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://earls.ca/locations/yaletown/menu/",
    websiteLink: "https://earls.ca/locations/yaletown/",
    reservationLink: "https://www.opentable.ae/r/earls-kitchen-and-bar-yaletown-vancouver?corrid=3f2fa233-444b-4e87-a5c4-0277499c4be4&searchDateTime=2020-10-20T19%3A00%3A00&partySize=2&returnTo=profile",
    latitude: 49.27665289999999,
    longitude: -123.1189534
  },
  {
    id: "8",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Heart and Crown",
    streetAddress: "3161 Strandherd Dr.",
    unitNumber: "",
    city: "Nepean",
    province: "ON",
    postalCode: "K2J 5N1",
    country: "Canada",
    operationHours: {
      Dimanche: "11pm - 2am",
      Lundi: "11pm - 2am",
      Mardi: "11pm - 2am",
      Mercredi: "11pm - 2am",
      Jeudi: "11pm - 2am",
      Vendredi: "11pm - 2am",
      Samedi: "11pm - 2am"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://heartandcrown.pub/barrhaven/menu-barrhaven/",
    websiteLink: "https://heartandcrown.pub/barrhaven/",
    reservationLink: null,
    latitude: 45.2753319,
    longitude: -75.7200775
  },
  {
    id: "9",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Le P'tit Caribou",
    streetAddress: "125 Chemin de Kandahar",
    unitNumber: "",
    city: "Mont-Tremblant",
    province: "QC",
    postalCode: "J8E 1E2",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 12am",
      Lundi: "12pm - 12am",
      Mardi: "12pm - 12am",
      Mercredi: "12pm - 12am",
      Jeudi: "12pm - 12am",
      Vendredi: "12pm - 12am",
      Samedi: "12pm - 12am"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://ptitcaribou.com/en/take-out-food-menu/",
    websiteLink: "http://ptitcaribou.com/en/",
    reservationLink: null,
    latitude: 46.2124835,
    longitude: -74.58666989999999
  },
  {
    id: "10",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "The Growling Gator",
    streetAddress: "86 Main St. W,",
    unitNumber: "",
    city: "Grand Bend",
    province: "ON",
    postalCode: "N0M 1T0",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 11pm",
      Lundi: "11am - 11pm",
      Mardi: "11am - 11pm",
      Mercredi: "11am - 11pm",
      Jeudi: "11am - 11pm",
      Vendredi: "11am - 11pm",
      Samedi: "11am - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.thegrowlinggator.com/index.php",
    websiteLink: "http://www.thegrowlinggator.com/",
    reservationLink: null,
    latitude: 43.3138088,
    longitude: -81.7603305
  },
  {
    id: "11",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "The Score",
    streetAddress: "107 King St. E.",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M5C 1G6",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 9pm",
      Lundi: "12pm - 9pm",
      Mardi: "12pm - 9pm",
      Mercredi: "12pm - 10pm",
      Jeudi: "12pm - 10pm",
      Vendredi: "12pm - 10pm",
      Samedi: "12pm - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://scoreonking.com/#masthead",
    websiteLink: "https://scoreonking.com/",
    reservationLink: null,
    latitude: 43.6501198,
    longitude: -79.37347369999999
  },
  {
    id: "12",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Brothers Tavern",
    streetAddress: "420 Main St,.",
    unitNumber: "",
    city: "Sicamous",
    province: "BC",
    postalCode: "V0E 2V0",
    country: "Canada",
    operationHours: {
      Dimanche: "9am - 11pm",
      Lundi: "9am - 11pm",
      Mardi: "9am - 11pm",
      Mercredi: "9am - 11pm",
      Jeudi: "9am - 11pm",
      Vendredi: "9am - 11pm",
      Samedi: "9am - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://brotherstavern.ca/menu/",
    websiteLink: "https://brotherstavern.ca/",
    reservationLink: null,
    latitude: 50.8359009,
    longitude: -118.9851952
  },
  {
    id: "13",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "The Cambie",
    streetAddress: "300 Cambie St",
    unitNumber: "",
    city: "Vancouver",
    province: "BC",
    postalCode: "V6B 2N3",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 11pm",
      Lundi: "11am - 11pm",
      Mardi: "11am - 11pm",
      Mercredi: "11am - 11pm",
      Jeudi: "11am - 11pm",
      Vendredi: "11am - 11pm",
      Samedi: "11am - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.cambiepubs.com/cambie-menu",
    websiteLink: "https://www.cambiepubs.com/",
    reservationLink: null,
    latitude: 49.2835381,
    longitude: -123.1091411
  },
  {
    id: "14",
    active: true,
    tierLevel: "Tier 1 (User Paid)",
    restaurantName: "Regulars",
    streetAddress: "668 King St. W.",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M5V 1M7",
    country: "Canada",
    operationHours: {
      Dimanche: "1pm - 9pm",
      Lundi: "4pm - 9pm",
      Mardi: "4pm - 9pm",
      Mercredi: "4pm - 9pm",
      Jeudi: "4pm - 9pm",
      Vendredi: "4pm - 9pm",
      Samedi: "1pm - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://regularsbar.ca/#menu",
    websiteLink:
      "https://regulars.business.site/?utm_source=gmb&utm_medium=referral",
    reservationLink: null,
    latitude: 43.64390350000001,
    longitude: -79.4026703
  },
  {
    id: "15",
    active: true,
    tierLevel: "Tier 1 (User Paid)",
    restaurantName: "Joe Dogs",
    streetAddress: "531 Brant St.",
    unitNumber: "",
    city: "Burlington",
    province: "ON",
    postalCode: "L7R 2G6",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 9pm",
      Lundi: "11am - 9pm",
      Mardi: "11am - 9pm",
      Mercredi: "11am - 9pm",
      Jeudi: "11am - 9pm",
      Vendredi: "11am - 9pm",
      Samedi: "11am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://joedogs.com/menu/",
    websiteLink: "https://joedogs.com/",
    reservationLink: null,
    latitude: 43.3292917,
    longitude: -79.80309249999999
  },
  {
    id: "16",
    active: true,
    tierLevel: "Tier 1 (User Paid)",
    restaurantName: "Cabana",
    streetAddress: "11 Polson St.",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M5A 1A4",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://cabanapoolbar.com/dining/",
    websiteLink: "https://cabanapoolbar.com/",
    reservationLink: "https://www.opentable.ca/r/cabana-waterfront-patio-restaurant-toronto",
    latitude: 43.6421134,
    longitude: -79.3527915
  },
  {
    id: "17",
    active: true,
    tierLevel: "Tier 1 (User Paid)",
    restaurantName: "C.P.R. Tavern",
    streetAddress: "671 Richmond St.",
    unitNumber: "",
    city: "London",
    province: "ON",
    postalCode: "N6A 5P6",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 10pm",
      Lundi: "12pm - 10pm",
      Mardi: "12pm - 10pm",
      Mercredi: "12pm - 10pm",
      Jeudi: "12pm - 10pm",
      Vendredi: "12pm - 10pm",
      Samedi: "12am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://barneyspatio.com/assets/menu/foodmenu.jpg",
    websiteLink: "https://barneyspatio.com/",
    reservationLink: null,
    latitude: 42.9932129,
    longitude: -81.25177819999999
  },
  {
    id: "18",
    active: true,
    tierLevel: "Tier 1",
    restaurantName: "Le Ciel Rose",
    streetAddress: "3709 Boul St-Laurent",
    unitNumber: "",
    city: "Montreal",
    province: "QC",
    postalCode: "H2X 2V7",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: null,
    websiteLink: null,
    reservationLink: null,
    latitude: 45.5146901,
    longitude: -73.5742452
  },
  {
    id: "19",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Cabot Links",
    streetAddress: "15933 Central Ave",
    unitNumber: "",
    city: "Inverness",
    province: "NS",
    postalCode: "B0E 1N0",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://cabotlinks.com/resort/dining",
    websiteLink: "https://cabotlinks.com/",
    reservationLink:
      "https://www.opentable.co.uk/restref/client/?rid=1005469&restref=1005469&r3uid=27j2PnoHZ&corrid=94bba812-35ad-468a-ba16-3a57e0ddeb38",
    latitude: 46.2333483,
    longitude: -61.30318130000001
  },
  {
    id: "20",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Salt Yard (Legendary)",
    streetAddress: "1601 Lower Water St",
    unitNumber: "",
    city: "Halifax",
    province: "NS",
    postalCode: "B3J 3P6",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://developns.ca/projects/salt-yard/",
    websiteLink: "https://developns.ca/projects/salt-yard/",
    reservationLink: null,
    latitude: 44.64688100000001,
    longitude: -63.57107209999999
  },
  {
    id: "21",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "The DEX",
    streetAddress: "1732 Argyle St.",
    unitNumber: "",
    city: "Halifax",
    province: "NS",
    postalCode: "B3J 2B6",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: null,
    websiteLink: null,
    reservationLink: null,
    latitude: 44.6477099,
    longitude: -63.57518109999999
  },
  {
    id: "22",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Golf de I'lile de Montreal",
    streetAddress: "3700 Rue Damien-Gauthier",
    unitNumber: "",
    city: "Montreal",
    province: "QC",
    postalCode: "H1A 5T4",
    country: "Canada",
    operationHours: {
      Dimanche: "6:30am - 10pm",
      Lundi: "6:30am - 10pm",
      Mardi: "6:30am - 10pm",
      Mercredi: "6:30am - 10pm",
      Jeudi: "6:30am - 10pm",
      Vendredi: "6:30am - 10pm",
      Samedi: "6:30am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.cgimgolf.com/en/facilities/restaurants/",
    websiteLink: "https://www.cgimgolf.com/en/",
    reservationLink: null,
    latitude: 45.6849147,
    longitude: -73.5030474
  },
  {
    id: "23",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "CECILE ET RAMONE GRILL",
    streetAddress: "1061 Pierre-Bertrand Blvd",
    unitNumber: "",
    city: "Québec City",
    province: "QC",
    postalCode: "G1M 2E8",
    country: "Canada",
    operationHours: {
      Dimanche: "FERMÉE",
      Lundi: "11am - 8pm",
      Mardi: "11am - 8pm",
      Mercredi: "11am - 8pm",
      Jeudi: "11am - 8:30pm",
      Vendredi: "11am - 8:30pm",
      Samedi: "11am - 8:30pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://cecileetramone.com/menu/",
    websiteLink: "https://cecileetramone.com/",
    reservationLink:
      "https://widgets.libroreserve.com/booking/2296e5ff55f3055/QC015512357293/seat",
    latitude: 46.8278725,
    longitude: -71.2760234
  },
  {
    id: "24",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Cafe Quatre Jeudis",
    streetAddress: "44 Rue Laval",
    unitNumber: "",
    city: "Gatineau",
    province: "QC",
    postalCode: "J8X 3G7",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://4jeudis.ca/fr/menus/",
    websiteLink: "http://4jeudis.ca/fr/",
    reservationLink: "http://4jeudis.ca/fr/contact/",
    latitude: 45.427093,
    longitude: -75.71625700000001
  },
  {
    id: "25",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Restaurant Marina Boucherville",
    streetAddress: "535 Boulevard Marie-Victorin",
    unitNumber: "",
    city: "Boucherville",
    province: "QC",
    postalCode: "J4B 8T4",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: null,
    websiteLink: null,
    reservationLink: null,
    latitude: 45.606324,
    longitude: -73.4566474
  },
  {
    id: "26",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "ANNIE'S SUR LE LAC",
    streetAddress: "76 Sainte-Anne St.",
    unitNumber: "",
    city: "Sainte-Anne-de-Bellevue",
    province: "QC",
    postalCode: "H9X 1L8",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.annies.ca/",
    websiteLink: "http://www.annies.ca/",
    reservationLink: "http://www.annies.ca/acceuil",
    latitude: 45.4034431,
    longitude: -73.95147759999999
  },
  {
    id: "27",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Restaurant Cabaret Liquor Store",
    streetAddress: "276 Rue Principale O, Magog, QC J1X 2A5",
    unitNumber: "",
    city: "Magog",
    province: "QC",
    postalCode: "J1X 2A5",
    country: "Canada",
    operationHours: {
      Dimanche: "8:30am - 10pm",
      Lundi: "11am - 10pm",
      Mardi: "11am - 8pm",
      Mercredi: "11am - 10pm",
      Jeudi: "11am - 10pm",
      Vendredi: "11am - 10pm",
      Samedi: "8am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://liquorstoremagog.ca/2_menus.html",
    websiteLink: "https://liquorstoremagog.ca/",
    reservationLink: "https://www.liquorstoremagog.ca/",
    latitude: 45.2651293,
    longitude: -72.148884
  },
  {
    id: "28",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Delice Resto Lounge Inc.",
    streetAddress: "146 Route du Président-Kennedy",
    unitNumber: "",
    city: "Lévis",
    province: "QC",
    postalCode: "G6V 6C9",
    country: "Canada",
    operationHours: {
      Dimanche: "9am - 9:30pm",
      Lundi: "9am - 9:30pm",
      Mardi: "9am - 9:30pm",
      Mercredi: "9am - 9:30pm",
      Jeudi: "9am - 9:30pm",
      Vendredi: "9am - 10pm",
      Samedi: "9am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://restodelice.com/fete-des-meres/",
    websiteLink: "http://delice.ca/",
    reservationLink:
      "https://widgets.libroreserve.com/booking/2320ed3359e9e7a/QC015820523723/seat",
    latitude: 46.7900475,
    longitude: -71.1688667
  },
  {
    id: "29",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Crazy Cactus",
    streetAddress: "269 3 Ave S",
    unitNumber: "",
    city: "Saskatoon",
    province: "SK",
    postalCode: "S7K 1M3",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 10pm",
      Lundi: "11am - 10pm",
      Mardi: "11am - 10pm",
      Mercredi: "11am - 10pm",
      Jeudi: "11am - 10pm",
      Vendredi: "11am - 10pm",
      Samedi: "11am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: null,
    websiteLink: "https://m.facebook.com/crazycactusyxe/?ref=bookmarks",
    reservationLink: null,
    latitude: 52.1268427,
    longitude: -106.6628175
  },
  {
    id: "30",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Rose & Crown Calgary",
    streetAddress: "1503 4 St SW",
    unitNumber: "",
    city: "Calgary",
    province: "AB",
    postalCode: "T2R 0Y1",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 11pm",
      Lundi: "11am - 11pm",
      Mardi: "11am - 11pm",
      Mercredi: "11am - 11pm",
      Jeudi: "11am - 11pm",
      Vendredi: "11am - 11pm",
      Samedi: "11am - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://roseandcrowncalgary.ca/menu-cv19/",
    websiteLink: "https://roseandcrowncalgary.ca/",
    reservationLink: "https://roseandcrowncalgary.ca/make-reservation/",
    latitude: 51.0392462,
    longitude: -114.0715187
  },
  {
    id: "31",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "The Drake",
    streetAddress: "909 Railway Ave",
    unitNumber: "",
    city: "Canmore",
    province: "AB",
    postalCode: "T1W 1P3",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 11pm",
      Lundi: "12pm - 11pm",
      Mardi: "12pm - 11pm",
      Mercredi: "12pm - 11pm",
      Jeudi: "12pm - 11pm",
      Vendredi: "12pm - 11pm",
      Samedi: "12pm - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.drakeinn.com/eat-and-drink",
    websiteLink: "https://www.drakeinn.com/",
    reservationLink:
      "https://www.opentable.ca/r/the-drake-pub-canmore?lang=EN&ref=18018&sp=ppc_g_ca_restaurantsaid%3D122986479520&tid=kwd-1217025977268&locp=1002273&loci=1001803&mt=&d=c&cid=512507860241&pos=&gclid=Cj0KCQjw4cOEBhDMARIsAA3XDRhRNeCzsi4ybt2pqkOhGgEjMOqd66REj0h64PcK_rlgXdZm0G1DTWcaAoogEALw_wcB",
    latitude: 51.0901978,
    longitude: -115.3547962
  },
  {
    id: "32",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "The Porch",
    streetAddress: "Labatt Brewing Company 700 58 Ave SE",
    unitNumber: "Bay #12",
    city: "Calgary",
    province: "AB",
    postalCode: "T2H 2E2",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://skyskate.theporchto.com/food-drink-menu/",
    websiteLink: "https://skyskate.theporchto.com/",
    reservationLink: "https://skyskate.theporchto.com/#bookings",
    latitude: 51.0018729,
    longitude: -114.0463103
  },
  {
    id: "33",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Lone Star",
    streetAddress: "251 Ontario St",
    unitNumber: "",
    city: "Kingston",
    province: "ON",
    postalCode: "K7L 2Z4",
    country: "Canada",
    operationHours: {
      Dimanche: "11:30am - 9pm",
      Lundi: "11:30am - 9pm",
      Mardi: "11:30am - 9pm",
      Mercredi: "11:30am - 9pm",
      Jeudi: "11:30am - 9pm",
      Vendredi: "11:30am - 9pm",
      Samedi: "11:30am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://lonestartexasgrill.com/menus#drinks",
    websiteLink: "https://lonestartexasgrill.com/locations",
    reservationLink: "https://lonestartexasgrill.com/reservations",
    latitude: 44.2305328,
    longitude: -76.4796777
  },
  {
    id: "34",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Lone Star",
    streetAddress: "128 George St,",
    unitNumber: "",
    city: "Ottawa",
    province: "ON",
    postalCode: "K1N 9N9",
    country: "Canada",
    operationHours: {
      Dimanche: "11:30am - 9pm",
      Lundi: "11:30pm - 9pm",
      Mardi: "11:30am - 9pm",
      Mercredi: "11:30am - 9pm",
      Jeudi: "11:30am - 9pm",
      Vendredi: "11:30am - 9pm",
      Samedi: "11:30am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://fajitastogo.com/orderdetails.html",
    websiteLink: "https://lonestartexasgrill.com/locations",
    reservationLink: "https://lonestartexasgrill.com/reservations",
    latitude: 45.4278748,
    longitude: -75.6903518
  },
  {
    id: "35",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Greta",
    streetAddress: "10141 109 St NW, Edmonton, AB",
    unitNumber: "",
    city: "Edmonton",
    province: "AB",
    postalCode: "T5J 3M5",
    country: "Canada",
    operationHours: {
      Dimanche: "4Pm - 11pm",
      Lundi: "FERMÉE",
      Mardi: "FERMÉE",
      Mercredi: "4pm - 11pm",
      Jeudi: "4pm - 11pm",
      Vendredi: "4pm - 11pm",
      Samedi: "4pm - 11pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://gretabar.com/yeg/street-food/",
    websiteLink: "https://gretabar.com/yeg/",
    reservationLink: "https://gretabar.com/yeg/bookings/",
    latitude: 53.5419657,
    longitude: -113.5084646
  },
  {
    id: "36",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Greta",
    streetAddress: "213 10 Ave SW,",
    unitNumber: "",
    city: "Calgary",
    province: "AB",
    postalCode: "T2R 0A4",
    country: "Canada",
    operationHours: {
      Dimanche: "4Pm - 10:30pm",
      Lundi: "FERMÉE",
      Mardi: "FERMÉE",
      Mercredi: "4pm - 10:30pm",
      Jeudi: "4pm - 10:30pm",
      Vendredi: "4pm - 10:30pm",
      Samedi: "4pm - 10:30pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://gretabar.com/yyc/menu/",
    websiteLink: "https://gretabar.com/yyc/",
    reservationLink: "https://gretabar.com/yyc/bookings/",
    latitude: 51.0434773,
    longitude: -114.0680989
  },
  {
    id: "37",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Boston Pizza",
    streetAddress: "1100 Bay St.",
    unitNumber: "",
    city: "Gravenhurst",
    province: "ON",
    postalCode: "P1P 1Z9",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://bostonpizza.com/en/menu.html",
    websiteLink: "https://bostonpizza.com/en/locations/gravenhurst.html",
    reservationLink: "https://bostonpizza.com/en/reservation.html",
    latitude: 44.9195978,
    longitude: -79.3859404
  },
  {
    id: "38",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Rec Room",
    streetAddress: "255 Bremner Blvd",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M5V 3M9",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink:
      "https://www.therecroom.com/toronto-roundhouse/restaurant/three10",
    websiteLink: "https://www.therecroom.com/?location=toronto-roundhouse",
    reservationLink:
      "https://www.opentable.ca/r/the-rec-room-toronto-roundhouse-toronto",
    latitude: 43.6420213,
    longitude: -79.3858211
  },
  {
    id: "39",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Jakes on Main",
    streetAddress: "202 Main St",
    unitNumber: "",
    city: "Unionville",
    province: "ON",
    postalCode: "L3R 2G9",
    country: "Canada",
    operationHours: {
      Dimanche: "FERMÉE",
      Lundi: "11:30am  - 2am",
      Mardi: "11:30am - 2am",
      Mercredi: " 11:30am - 2am",
      Jeudi: "11:30am - 2am",
      Vendredi: " 11:30am - 2am",
      Samedi: "11:30am - 2am"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.jakesonmainunionville.com/#Menu_Section",
    websiteLink: "http://www.jakesonmainunionville.com/",
    reservationLink: "http://www.jakesonmainunionville.com/contact.html",
    latitude: 43.867126,
    longitude: -79.31201
  },
  {
    id: "40",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "La Cage",
    streetAddress: "150 Rue Sainte-Catherine Ouest local 201C",
    unitNumber: "",
    city: "Montréal",
    province: "QC",
    postalCode: "H2X 3Y2",
    country: "Canada",
    operationHours: {
      Dimanche: "4pm - 8pm",
      Lundi: "11am  - 8pm",
      Mardi: "11am - 8pm",
      Mercredi: " 11am - 8pm",
      Jeudi: "11am- 9pm",
      Vendredi: " 11am - 9pm",
      Samedi: "4pm - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://menu.cage.ca/complexe-desjardins",
    websiteLink: "https://www.cage.ca/complexe-desjardins",
    reservationLink: "https://www.cage.ca/reservation",
    latitude: 45.5076517,
    longitude: -73.5653556
  },
  {
    id: "41",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "St Huberts",
    streetAddress: "1019 Rue Sainte-Catherine Est",
    unitNumber: "",
    city: "Montréal",
    province: "QC",
    postalCode: "H2L 2G4",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.st-hubert.com/fr/menu.html",
    websiteLink:
      "https://www.st-hubert.com/fr/restaurants/restaurant-st-hubert-village-montreal.html",
    reservationLink:
      "https://www.st-hubert.com/fr/restaurants/reservations.html",
    latitude: 45.51731669999999,
    longitude: -73.5572614
  },
  {
    id: "42",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Sunnyside Pavilion Café",
    streetAddress: "1755 Lake Shore Blvd W",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M6S 5A3",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.sunnysidepavilion.com/menu2/",
    websiteLink: "http://www.sunnysidepavilion.com/",
    reservationLink: "http://www.sunnysidepavilion.com/contact-us/",
    latitude: 43.6379564,
    longitude: -79.45774
  },
  {
    id: "43",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Beaver & Bulldog",
    streetAddress: "2020 Lakeshore Rd.",
    unitNumber: "",
    city: "Burlington",
    province: "ON",
    postalCode: "L7R 4G8",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 7pm",
      Lundi: "FERMÉE",
      Mardi: "FERMÉE",
      Mercredi: " 2pm - 10pm",
      Jeudi: "2pm - 10pm",
      Vendredi: " 2pm - 10pm",
      Samedi: "12pm - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.waterfronthotelburlington.com/dining.html",
    websiteLink: "https://www.waterfronthotelburlington.com/dining.html",
    reservationLink: "https://www.opentable.ca/r/beaver-and-bulldog-burlington",
    latitude: 43.3245726,
    longitude: -79.7958305
  },
  {
    id: "44",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Two Amigos",
    streetAddress: "914 Murphy Rd",
    unitNumber: "1",
    city: "Sarnia",
    province: "ON",
    postalCode: "N75 5C4",
    country: "Canada",
    operationHours: {
      Dimanche: "4pm - 9pm",
      Lundi: "4pm - 9pm",
      Mardi: "4pm - 9pm",
      Mercredi: " 4pm - 9pm",
      Jeudi: "4pm - 9pm",
      Vendredi: " 12pm - 9pm",
      Samedi: "12pm - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.twoamigossarnia.com/menu",
    websiteLink: "https://www.twoamigossarnia.com/",
    reservationLink: "https://www.opentable.ca/r/two-amigos-sarnia",
    latitude: 42.9886646,
    longitude: -82.36623279999999
  },
  {
    id: "45",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Los Puntos Cantina",
    streetAddress: "128 Michigan Ave",
    unitNumber: "",
    city: "Point Edward",
    province: "ON",
    postalCode: "N7V 1E6",
    country: "Canada",
    operationHours: {
      Dimanche: "FERMÉE",
      Lundi: "FERMÉE",
      Mardi: "11am - 9pm",
      Mercredi: " 11am - 9pm",
      Jeudi: "11am - 9pm",
      Vendredi: " 11am - 9pm",
      Samedi: "11am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://lospuntoscantina.com/menu.html",
    websiteLink: "https://lospuntoscantina.com/",
    reservationLink: "https://lospuntoscantina.com/contact.html",
    latitude: 42.9979525,
    longitude: -82.417338
  },
  {
    id: "46",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Banditos",
    streetAddress: "683 Bank St.",
    unitNumber: "",
    city: "Ottawa",
    province: "ON",
    postalCode: "K1S 3T8",
    country: "Canada",
    operationHours: {
      Dimanche: "2pm- 8pm",
      Lundi: "2pm- 8pm",
      Mardi: "2pm- 8pm",
      Mercredi: "2pm- 8pm",
      Jeudi: "2pm- 8pm",
      Vendredi: "2pm- 8pm",
      Samedi: "2pm- 8pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.banditosottawa.com/",
    websiteLink: "https://www.banditosottawa.com/",
    reservationLink: "https://www.banditosottawa.com/",
    latitude: 45.4054628,
    longitude: -75.68983159999999
  },
  {
    id: "47",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "The Slip",
    streetAddress: "235 Queens Quay W.",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M5J 2G6",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.theslip.ca/menu",
    websiteLink: "http://www.theslip.ca/",
    reservationLink: "http://www.theslip.ca/",
    latitude: 43.63982379999999,
    longitude: -79.3814175
  },
  {
    id: "48",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "On the Docks",
    streetAddress: "90 Main St E,",
    unitNumber: "",
    city: "Huntsville",
    province: "ON",
    postalCode: "P1H 2C7",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 9pm",
      Lundi: "11am - 9pm",
      Mardi: "11am - 9pm",
      Mercredi: " 11am - 9pm",
      Jeudi: "11am - 9pm",
      Vendredi: " 11am - 9pm",
      Samedi: "11am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.onthedockspub.com/menu.html",
    websiteLink: "http://www.onthedockspub.com/",
    reservationLink: "http://www.onthedockspub.com/contact.html",
    latitude: 45.3270522,
    longitude: -79.2165722
  },
  {
    id: "49",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Rikochez",
    streetAddress: "54 Ontario St",
    unitNumber: "",
    city: "Grimsby",
    province: "ON",
    postalCode: "L3M 3H3",
    country: "Canada",
    operationHours: {
      Dimanche: "2pm - 9pm",
      Lundi: "2pm - 8pm",
      Mardi: "2pm - 8pm",
      Mercredi: " 2pm- 8pm",
      Jeudi: "11am - 9pm",
      Vendredi: " 2pm - 9pm",
      Samedi: "2pm - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.rikochez.ca/menus",
    websiteLink: "https://www.rikochez.ca/",
    reservationLink: "https://www.rikochez.ca/",
    latitude: 43.1960087,
    longitude: -79.55772979999999
  },
  {
    id: "50",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Abbey Road Taphouse",
    streetAddress: "1851 Sumas Way",
    unitNumber: "",
    city: "Abbotsford",
    province: "BC",
    postalCode: "V25 4L5",
    country: "Canada",
    operationHours: {
      Dimanche: "10am - 10pm",
      Lundi: "11:30am - 10pm",
      Mardi: "11:30am - 10pm",
      Mercredi: " 11:30am- 10pm",
      Jeudi: "11:30am - 10pm",
      Vendredi: " 11:30pm - 10pm",
      Samedi: "11:30am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://www.abbeyroadtaphouse.com/food.html",
    websiteLink: "http://www.abbeyroadtaphouse.com/",
    reservationLink: "http://www.abbeyroadtaphouse.com/contact.html",
    latitude: 49.0312552,
    longitude: -122.2657111
  },
  {
    id: "51",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Ocean Park Pub",
    streetAddress: "12822 16 AVE",
    unitNumber: "",
    city: "Surrey",
    province: "BC",
    postalCode: "V4A 1N4",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 10pm",
      Lundi: "11am - 10pm",
      Mardi: "11am - 10pm",
      Mercredi: " 11pm- 10pm",
      Jeudi: "11:30am - 10pm",
      Vendredi: " 11am - 10pm",
      Samedi: "11am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink:
      "http://www.oceanparkpizza.com/docs/ocean-park-village-pub-menu-revised-september-2020.pdf",
    websiteLink: "http://www.oceanparkpizza.com/",
    reservationLink: "http://www.oceanparkpizza.com/contact",
    latitude: 49.0312916,
    longitude: -122.8670359
  },
  {
    id: "52",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "LEGENDS NEIGHBOURHOOD PUB",
    streetAddress: "9031 BLUNDELL RD",
    unitNumber: "",
    city: "Richmond",
    province: "BC",
    postalCode: "V6Y 1K4",
    country: "Canada",
    operationHours: {
      Dimanche: "10am - 12am",
      Lundi: "11am - 12am",
      Mardi: "11am - 12am",
      Mercredi: " 11am- 12am",
      Jeudi: "11am - 12am",
      Vendredi: " 11am - 12am",
      Samedi: "10am - 12am"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "http://legendspub.com/menu/",
    websiteLink: "http://legendspub.com/",
    reservationLink: "https://legendspub.com/contact/",
    latitude: 49.1554846,
    longitude: -123.1244095
  },
  {
    id: "53",
    active: true,
    tierLevel: "Tier 2",
    restaurantName: "Marr Hotel - The GPO Bar + Kitchen",
    streetAddress: "136 W CORDOVA STREET",
    unitNumber: "",
    city: "Vancouver",
    province: "BC",
    postalCode: "V6B 2N3",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 10pm",
      Lundi: "12pm - 10pm",
      Mardi: "12pm - 10pm",
      Mercredi: " 12pm- 10pm",
      Jeudi: "12pm - 10pm",
      Vendredi: " 12pm - 10pm",
      Samedi: "11am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.thegpobar.com/menu-1",
    websiteLink: "https://www.thegpobar.com/",
    reservationLink: "https://www.thegpobar.com/contact",
    latitude: 49.2834087,
    longitude: -123.1089363
  },
  {
    id: "54",
    active: false,
    tierLevel: "User Paid",
    restaurantName: "Ceili's on 4th - The Rooftop YYC",
    streetAddress: "351 4 Ave SW",
    unitNumber: "",
    city: "Calgary",
    province: "AB",
    postalCode: "T2P 0J4",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.ceilisdt.ca/fourth-ave-food-menu",
    websiteLink: "https://www.ceilisdt.ca/",
    reservationLink:
      "https://www.tbdine.com/book/restaurant/ceilis-on-4th?idApp=68941&language=en",
    latitude: 51.049539,
    longitude: -114.07011
  },
  {
    id: "55",
    active: true,
    tierLevel: "User Paid",
    restaurantName: "Paddy Flaherty's",
    streetAddress: "130 Seaway Rd, Sarnia",
    unitNumber: "",
    city: "Sarnia",
    province: "ON",
    postalCode: "N7T 845",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 9pm",
      Lundi: "11am - 9pm",
      Mardi: "11am - 9pm",
      Mercredi: " 11am- 9pm",
      Jeudi: "11am - 9pm",
      Vendredi: " 11am - 9pm",
      Samedi: "11am - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.paddyflahertys.com/en/pubfare.html",
    websiteLink: "https://www.paddyflahertys.com/",
    reservationLink:
      "https://www.opentable.ca/r/paddy-flahertys-sarnia?ref=16423",
    latitude: 42.9827857,
    longitude: -82.410898
  },
  {
    id: "56",
    active: true,
    tierLevel: "User Paid",
    restaurantName: "Grog's",
    streetAddress: "8604 Lakeshore Rd",
    unitNumber: "",
    city: "Thedford",
    province: "ON",
    postalCode: "N0M 2N0",
    country: "Canada",
    operationHours: {
      Dimanche: "11am - 10pm",
      Lundi: "11am - 10pm",
      Mardi: "11am - 10pm",
      Mercredi: " 11am- 10pm",
      Jeudi: "11am - 10pm",
      Vendredi: " 11am - 10pm",
      Samedi: "11am - 10pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.grogs.ca/?page_id=22",
    websiteLink: "https://www.grogs.ca/",
    reservationLink: "https://www.grogs.ca/?page_id=20",
    latitude: 43.1329138,
    longitude: -82.0498188
  },
  {
    id: "57",
    active: true,
    tierLevel: "User Paid",
    restaurantName: "Le quartier général",
    streetAddress: "1251 Rue Gilford",
    unitNumber: "",
    city: "Montreal",
    province: "QC",
    postalCode: "H2J 1R3",
    country: "Canada",
    operationHours: {
      Dimanche: "",
      Lundi: "",
      Mardi: "",
      Mercredi: "",
      Jeudi: "",
      Vendredi: "",
      Samedi: ""
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://lequartiergeneral.ca/accueil",
    websiteLink: "https://lequartiergeneral.ca/",
    reservationLink: "https://www.bookenda.com/le-quartier-general",
    latitude: 45.53135409999999,
    longitude: -73.5810391
  },
  {
    id: "58",
    active: true,
    tierLevel: "User Paid",
    restaurantName: "Lazy Flamingo",
    streetAddress: "19 Hess St S,",
    unitNumber: "",
    city: "Hamilton",
    province: "ON",
    postalCode: "L8P 3M7",
    country: "Canada",
    operationHours: {
      Dimanche: "12pm - 9pm",
      Lundi: "12pm - 9pm",
      Mardi: "12pm - 9pm",
      Mercredi: " 12pm- 9pm",
      Jeudi: "12pm - 9pm",
      Vendredi: " 12pm - 9pm",
      Samedi: "12pm - 9pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: null,
    websiteLink: "https://www.facebook.com/thelazyflamingo/",
    reservationLink: "http://legendspub.com/contact/",
    latitude: 43.2580975,
    longitude: -79.8777011
  },
  {
    id: "59",
    active: true,
    tierLevel: "User Paid",
    restaurantName: "Delta - SOCO Kitchen + Bar",
    streetAddress: "75 Lower Simcoe St,",
    unitNumber: "",
    city: "Toronto",
    province: "ON",
    postalCode: "M5J 3A6",
    country: "Canada",
    operationHours: {
      Dimanche: "8am - 8pm",
      Lundi: "8am - 8pm",
      Mardi: "8am - 8pm",
      Mercredi: " 8am - 8pm",
      Jeudi: "8am - 8pm",
      Vendredi: " 8am - 8pm",
      Samedi: "8am - 8pm"
    },
    imageUrl: null,
    beerDeal:
      "http://www.doylo.com.au/wp-content/uploads/2016/09/corona-buckets.jpg",
    menuLink: "https://www.socokitchenandbar.ca/our-menus",
    websiteLink: "https://www.socokitchenandbar.ca/",
    reservationLink:
      "https://www.opentable.ca/r/soco-kitchen-and-bar-toronto?ref=16423",
    latitude: 43.64239449999999,
    longitude: -79.3840129
  }
];
